import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Button } from "@mui/material";
import { wwwLinks } from "../../variables/wwwRoutes";
const Animation = ({ sx = {}, ...props }) => {
    return (_jsx(Box, { component: 'video', autoPlay: true, loop: true, muted: true, sx: sx, ...props, children: _jsx("source", { src: 'https://ramibarilan-photos-dev.s3.amazonaws.com/ANIMATION+TIMELINE+02+CUT+SMALL.mp4', type: 'video/mp4' }, void 0) }, void 0));
};
export const RamiStrip = () => {
    return (_jsx(Button, { onClick: wwwLinks.home, sx: { position: 'relative', zIndex: 1200 }, children: _jsx(Animation, {}, void 0) }, void 0));
};
//# sourceMappingURL=RamiStrip.js.map